import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  notification: {
    flexDirection: 'row',
    padding: 15,
    marginBottom: 12,
    borderRadius: 6,
    elevation: 2,
    backgroundColor: 'white',
    shadowColor: colors.black,
    shadowOpacity: 0.2,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 2 },
    flex: 1,
    alignSelf: 'flex-end',
    minWidth: 215,
  },
  notificationContainer: {
    flex: 1,
    maxWidth: '50%',
    position: 'absolute',
    top: 40,
    right: 30,
    zIndex: 9999,
    alignItems: 'flex-end',
    pointerEvents: 'box-none',
  },
  message: {
    marginVertical: 8,
  },
  children: {
    minWidth: 0,
    flexShrink: 1,
  },
  noMessageChildren: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  closeContainer: {
    marginLeft: 30,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-around',
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  icon: {
    marginRight: 26,
  },
  notificationBase: {
    borderWidth: 1,
  },
  success: {
    backgroundColor: colors.newUI.therapist.green30,
    borderColor: colors.newUI.therapist.brandGreen,
  },
  successText: {
    color: colors.newUI.therapist.green90,
  },
  error: {
    backgroundColor: colors.newUI.therapist.red30,
    borderColor: colors.newUI.therapist.red70,
  },
  errorText: {
    color: colors.newUI.therapist.red90,
  },
  info: {
    backgroundColor: colors.white,
    borderColor: colors.newUI.therapist.blue60,
  },
  infoText: {
    color: colors.newUI.therapist.textBlue100,
  },
  alert: {
    backgroundColor: colors.newUI.therapist.orange30,
    borderColor: colors.newUI.therapist.orange60,
  },
  alertText: {
    color: colors.newUI.therapist.orange90,
  },
  title: {
    fontWeight: 'bold',
    paddingRight: 5,
  },
});
